import { Temporal } from '@js-temporal/polyfill';
import style from './Footer.module.css';

export const Footer = ({ children }) => {
  const now = Temporal.Now.plainDateISO();
  const currentYear = now.year;
  return (<div className={style.footer}>
    <small>Developed {currentYear} | ver 0.1 | {children}</small>
  </div>)
}